/* src/app/modules/expense/ia/ia.component.css */
table {
  width: 100%;
}
table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
}
td.mat-mdc-cell {
  padding: 2px 5px !important;
}
/*# sourceMappingURL=ia.component.css.map */
